import { render, staticRenderFns } from "./WithdrawEnrolmentReport.vue?vue&type=template&id=f86ba1da&scoped=true"
import script from "./WithdrawEnrolmentReport.vue?vue&type=script&lang=js"
export * from "./WithdrawEnrolmentReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f86ba1da",
  null
  
)

export default component.exports